import React from "react";

/** One line shown where Edit / Save buttons are hidden because the user has View rights only (Users › Access rights). */
export default function ViewOnlyNote({ right = "Edit" }) {
  return (
    <p className="mst-drawer-hint mst-view-only">
      <i className="fas fa-lock" aria-hidden="true" /> View only — ask an administrator for {right} rights.
    </p>
  );
}
